import React from 'react'

const Manual_quickbook_ingles = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Conectar Quickbook - Inglés</h2>
        <iframe
          src="https://scribehow.com/embed/Conectar_Quickbook__Ingles__HvRATmBrRq-S2XZ2Nmaotw?as=scrollable"
          className="scribe-iframe-general-188"
          width="100%"
          height="800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_quickbook_ingles
